export default __webpack_public_path__ + "static/around2-60ffd60a9f745f4afc1323293f3e367a.png";